__turbopack_context__.v({
  "dropdownButton": "SuperHeader-module__SqhECG__dropdownButton",
  "dropdownItem": "SuperHeader-module__SqhECG__dropdownItem",
  "langDropdown": "SuperHeader-module__SqhECG__langDropdown",
  "languageItem": "SuperHeader-module__SqhECG__languageItem",
  "navItem": "SuperHeader-module__SqhECG__navItem",
  "navList": "SuperHeader-module__SqhECG__navList",
});
